import { html } from "lit";
import { u } from "@converse/headless";

export default (channel_or_video, is_video, url, hide_url) => {
    const { hostname } = u.getURL(url);
    const parent = window.location.hostname;
    const src = is_video
        ? `https://player.twitch.tv/?video=${channel_or_video}&parent=${parent}&autoplay=false`
        : `https://player.twitch.tv/?channel=${channel_or_video}&parent=${parent}&autoplay=false`;
    return html`<figure><iframe style="border-radius:12px" src="${src}" width="100%" height="315" frameborder="0" allowfullscreen="" allow="autoplay; fullscreen" loading="lazy"></iframe>${hide_url ? "" : html`<a target="_blank" rel="noopener" title="${url}" href="${url}">${hostname}</a>`}</figure>`;
};
